import { render } from "./FilterCollapse.vue?vue&type=template&id=7ecf0526"
import script from "./FilterCollapse.vue?vue&type=script&lang=js"
export * from "./FilterCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlideTransition,QSpinner,QBtn});
